export default "__VITE_ASSET__Bs7SgyXf__"